import type { SVGProps } from 'react';
import * as React from 'react';

const PdfIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={40} height={44} viewBox="0 0 40 44" fill="none" aria-hidden="true" {...props}>
    <g id="file-icon/pdf">
      <g id="Vector" filter="url(#filter0_dd_3816_37868)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L35.3334 10.1111V38.3333C35.3334 39.8061 34.1505 41 32.6777 41C27.0142 41 13.7443 41 7.32677 41C5.85401 41 4.66675 39.82 4.66675 38.3473C4.66675 30.3468 4.66675 10.7752 4.66675 3.6498C4.66675 2.17704 5.86066 1 7.33341 1H26.2223Z"
          fill="#DC2626"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L35.3334 10.1111V38.3333C35.3334 39.8061 34.1505 41 32.6777 41C27.0142 41 13.7443 41 7.32677 41C5.85401 41 4.66675 39.82 4.66675 38.3473C4.66675 30.3468 4.66675 10.7752 4.66675 3.6498C4.66675 2.17704 5.86066 1 7.33341 1H26.2223Z"
          fill="url(#paint0_radial_3816_37868)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L26.2223 7.44444C26.2223 8.9172 27.4162 10.1111 28.889 10.1111L35.3334 10.1111L26.2223 1Z"
          fill="white"
          fillOpacity={0.3}
        />
      </g>
      <path
        id="Vector_2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6295 13.8889C17.4779 13.8889 16.5308 14.836 16.5308 15.9877C16.5308 17.4194 17.3262 19.1967 18.1639 20.8673C17.5091 22.9169 16.7661 25.1134 15.8159 26.9669C15.4717 27.1019 15.1341 27.2308 14.8058 27.3562C13.2787 27.9393 11.9519 28.446 11.0936 29.1378C11.0774 29.1544 11.0621 29.1719 11.0477 29.1902C10.6667 29.5799 10.4443 30.1105 10.4443 30.679C10.4443 31.8307 11.3914 32.7778 12.5431 32.7778C13.1047 32.7778 13.6468 32.5682 14.0385 32.1679C14.052 32.1575 14.0652 32.1465 14.0778 32.1351C14.8454 31.2185 15.7505 29.5557 16.557 28.0359C18.4156 27.3048 20.3636 26.5608 22.2433 26.1142C23.6156 27.2201 25.6008 27.9506 27.2345 27.9506C28.3861 27.9506 29.3332 27.0035 29.3332 25.8519C29.3332 24.7002 28.3861 23.7531 27.2345 23.7531C25.9243 23.7531 24.0204 24.2208 22.5647 24.7107C21.3848 23.603 20.3007 22.2195 19.5215 20.7493C19.6057 20.4898 19.6921 20.2302 19.778 19.972L19.778 19.972C20.2601 18.5238 20.7283 17.1169 20.7283 15.9877C20.7283 14.836 19.7812 13.8889 18.6295 13.8889ZM18.6288 15.1487C19.0999 15.1487 19.4683 15.5171 19.4683 15.9882C19.4683 16.6181 19.131 17.7779 18.7403 19.0248C18.2183 17.8118 17.7893 16.648 17.7893 15.9882C17.7893 15.5171 18.1577 15.1487 18.6288 15.1487ZM21.168 25.0975C20.3611 24.2682 19.6217 23.3338 18.9905 22.3298C18.5514 23.6659 18.0876 25.0229 17.5083 26.3305C18.7078 25.8739 19.9234 25.4378 21.168 25.0975ZM27.2349 25.0124C27.706 25.0124 28.0744 25.3808 28.0744 25.8519C28.0744 26.323 27.706 26.6914 27.2349 26.6914C26.2891 26.6914 24.9449 26.2645 23.8703 25.6683C25.1038 25.3195 26.4497 25.0124 27.2349 25.0124ZM13.121 31.3012C13.5313 30.8064 14.118 29.8231 14.7082 28.7696C13.4908 29.2568 12.4197 29.7134 11.9273 30.0944C11.7985 30.2362 11.7043 30.4564 11.7043 30.6781C11.7043 31.1492 12.0727 31.5176 12.5438 31.5176C12.7943 31.5176 12.9808 31.4352 13.121 31.3012Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_dd_3816_37868"
        x={2.66675}
        y={0}
        width={34.6667}
        height={44}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={0.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3816_37868" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_3816_37868" result="effect2_dropShadow_3816_37868" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3816_37868" result="shape" />
      </filter>
      <radialGradient
        id="paint0_radial_3816_37868"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(20.0001 0.999999) rotate(90) scale(40 40.1825)"
      >
        <stop offset={0.297418} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.08} />
      </radialGradient>
    </defs>
  </svg>
);
export default PdfIcon;
